import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { translate } from 'utils/translations'
import { replaceTranslationVariables } from 'utils/text-transformation'
import { AI_VIDEO_MODEL_CODES } from 'consts'
import { T } from 'consts/translationKeys'

export const useRecommendedSizeLabel = () => {
  const selectedModel = useSelector(aiVideoSelectors.selectedModel)
  const recommendedSize = useMemo(() => {
    switch (selectedModel?.model) {
      case AI_VIDEO_MODEL_CODES.SORA_2:
        return `1280x720 ${translate(T.OR_LABEL)} 720x1280`
      default:
        return ''
    }
  }, [selectedModel])

  return recommendedSize
    ? replaceTranslationVariables(
        translate(T.RECOMMENDED_REF_IMAGE_SIZE_LABEL),
        [recommendedSize]
      )
    : ''
}
